<div
  style="z-index: 999999"
  class="fixed top-0 left-0 flex flex-col items-center justify-center w-full h-full loader-container"
  [ngClass]="className"
>
  <div
    class="flex flex-col items-center justify-center p-3 bg-white bg-opacity-50 backdrop-blur-sm rounded-3xl"
  >
    <mat-spinner [diameter]="40"></mat-spinner>
    <p *ngIf="text" class="mt-5 mb-0 font-bold">{{text}}</p>
  </div>
</div>
